module.exports = __webpack_public_path__ + "img/project-38.6fe82a3c.png";